module.exports = __webpack_public_path__ + "img/jxpgbj.4dc0fec4.png";